import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import TextFiled from "../../../components/common/InputField/TextFiled";
import InlineError from "../../../components/common/InlineError/InlineError";
import MainButton from "../../../components/common/MainButton/MainButton";
import Snippet from "../../../components/common/SnippetIcon/Snippet";
import Heading from "../../../components/common/Typography/Heading";
import ButtonText from "../../../components/common/Typography/ButtonText";
import Paragraph from "../../../components/common/Typography/Paragraph";
import SpecialText from "../../../components/common/Typography/SpecialText";
import WrittenStepper from "../../../components/common/StepIndicater/WrittenStepper";
import Title from "../../../components/common/Title/Title";
import Spinner from "../../../components/common/Spinner";
import Alerts from "../../../components/common/Alerts/Alerts";
import StepBackButton from "../../../components/common/StepBackButton/StepBackButton";
import { formatABN } from "../../../utils/abnUtils";

import { useGraphQL } from "../../../context/GraphQLProvider";
import { BusinessInformationSchema } from "../../../FormValidations/SignUpSchema";
import { UpdateUserMutation } from "../../../services/SignUp";
import { setField, setStep } from "../../../Redux/Slice/SignUp";
import SelectService from "../SelectService/SelectService";
import PrimarySkills from "../PrimarySkills/PrimarySkills";
import Location from "../../SignUp/Location/Location";
import AddProfilePicture from "../../SignUp/AddProfilePicture/AddProfilePicture";
import ProfilePreview from "../ProfilePreview/ProfilePreview";
import { transformToUserInput } from "../../../utils/userInputUtils";
import { POPUP_FORM_CONTENT_CLASS } from "../../../components/popup/popupLayoutSpec";

const BusinessInfo = ({ onClickHandler }) => {
  const graphqlService = useGraphQL();
  const [RequestStart, setRequetStart] = useState(false);
  const dispatch = useDispatch();
  const InitialValues = useSelector((state) => state.signup);
  const { id, email, step } = useSelector((state) => state.signup);

  const [mainCategory, setMainCategory] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [showABNField, setShowABNField] = useState(true);
  const [showBusinessNameField, setShowBusinessNameField] = useState(false);
  const [abnStep, setAbnStep] = useState(true);
  const [businessNameStep, setBusinessNameStep] = useState(false);

  const handleABNChange = (e) => {
    const formattedValue = formatABN(e.target.value);
    formik.setFieldValue('abn', formattedValue);
  };

  const handleStepChange = (newStep) => {
    dispatch(setStep(newStep));
  };

  const handleABNNext = (e) => {
    e.preventDefault();
    if (!formik.errors.abn) {
      dispatch(setField({ abn: formik.values.abn || '' }));
      setShowBusinessNameField(true);
      setBusinessNameStep(true);
      setAbnStep(false);
    } else {
      formik.setFieldTouched('abn', true);
    }
  };

  const handleBusinessNameNext = (e) => {
    e.preventDefault();
    if (formik.values.businessName && !formik.errors.businessName) {
      dispatch(setField({ businessName: formik.values.businessName }));
      formik.handleSubmit();
    } else {
      formik.setFieldTouched('businessName', true);
    }
  };

  const handleBackToABN = () => {
    setShowBusinessNameField(false);
    setBusinessNameStep(false);
    setShowABNField(true);
    setAbnStep(true);
  };

  const UpdateBusinessInformation = (gql, values) => {
    setRequetStart(true);
    dispatch(setField(values));
    const userInput = transformToUserInput(InitialValues);
    userInput.userInput.abn = values.abn;
    userInput.userInput.businessName = values.businessName;

    UpdateUserMutation(gql, userInput)
      .then((response) => {
        if (
          response.updateUserProfile?.abn === values.abn &&
          response.updateUserProfile?.businessName === values.businessName
        ) {
          handleStepChange(5);
          setRequetStart(false);
        }
      })
      .catch((error) => {
        Alerts.error(error);
      })
      .finally(() => {
        // handleStepChange(5);
        setRequetStart(false);
      });
  };

  const formik = useFormik({
    initialValues: InitialValues,
    validationSchema: BusinessInformationSchema,
    onSubmit: (values) => {
      UpdateBusinessInformation(graphqlService, values);
    },
  });

  // const servicesNames = [
  //   { name: "Air conditioning & Heating" },
  //   { name: "Architectural Services" },
  //   { name: "Bricklaying & Blockwork" },
  //   { name: "Cabinet Making" },
  //   { name: "Carpentry" },
  //   { name: "Caulking Services" },
  //   { name: "Cleaning Services" },
  //   { name: "Concrete & Paving" },
  //   { name: "Conveyancing" },
  //   { name: "Decking, Gazebo & Carports" },
  //   { name: "Demolition & Excavation" },
  //   { name: "Electrical Services" },
  //   { name: "Engineering Services" },
  //   { name: "Fencing & Gates" },
  //   { name: "Garden & Landscaping" },
  //   { name: "Glass & Glazing" },
  //   { name: "Handyman Services" },
  //   { name: "Inspections & Surveyors" },
  //   { name: "Insulation Services" },
  //   { name: "Interior Design" },
  //   { name: "Locksmiths" },
  //   { name: "Mould & Asbestos" },
  //   { name: "Moving & Delivery" },
  //   { name: "Painting & Decorating" },
  //   { name: "Pest Control" },
  //   { name: "Plumbing" },
  //   { name: "Pools & Spas" },
  //   { name: "Rendering" },
  //   { name: "Renovation & Restoration" },
  //   { name: "Roofing" },
  //   { name: "Scaffolding" },
  //   { name: "Shopfitting" },
  //   { name: "Skip Bins" },
  //   { name: "Solar Power" },
  //   { name: "Staircase Services" },
  //   { name: "Stonework" },
  //   { name: "Tiling" },
  //   { name: "Waterproofing" },
  // ];

  return (
    <>
      {RequestStart && <Spinner />}
      <div className="overflow-auto relative flex items-center justify-center" style={{ minHeight: 'calc(100vh - 120px)' }}>
        <div className={POPUP_FORM_CONTENT_CLASS}>
          {step === 4 && (
            <>
              <Heading
                variant={"h6"}
                className={
                  "flex items-center justify-center text-center text-offblack"
                }
              >
                Add Business Details
              </Heading>
              <div className="mt-10 xl:mt-[60px] w-full">
                <form>
                  <div className="flex justify-center w-full">
                    <div className="w-full mx-auto">
                      {/* ABN field - only show when in ABN step */}
                      {showABNField && !showBusinessNameField && (
                        <div>
                          <TextFiled
                            className={"lg:bg-white"}
                            variant={"general"}
                            fullWidth
                            label={"ABN"}
                            name="abn"
                            value={formik.values.abn}
                            placeholder={
                              "Enter your Australian Business Number (ABN) - Optional"
                            }
                            star={false}
                            onChange={handleABNChange}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                e.preventDefault();
                                if (!formik.errors.abn) {
                                  handleABNNext(e);
                                } else {
                                  formik.setFieldTouched('abn', true);
                                }
                              }
                            }}
                          />
                          <div className="flex items-center justify-between gap-3 mt-1">
                            <div className="flex-1 min-w-0 [&>div]:mt-0">
                              <InlineError
                                message={
                                  formik.touched.abn && formik.errors.abn
                                    ? formik.errors.abn
                                    : null
                                }
                              />
                            </div>
                            <a
                              href="https://abr.business.gov.au/"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="shrink-0"
                            >
                              <div className="group relative cursor-pointer">
                                <ButtonText
                                  variant={"SecondaryText"}
                                  className="text-primaryblue link-cta--below-field"
                                >
                                  Look Up (ABN)
                                </ButtonText>
                              </div>
                            </a>
                          </div>
                        </div>
                      )}

                      {/* Business name field - only show when in business name step */}
                      {showBusinessNameField && (
                        <div>
                          <TextFiled
                            variant={"general"}
                            fullWidth
                            label={"Business name"}
                            name="businessName"
                            value={formik.values.businessName}
                            placeholder={"Enter your business name"}
                            star={true}
                            onChange={formik?.handleChange}
                            error={formik.touched.businessName && formik.errors.businessName ? formik.errors.businessName : null}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                e.preventDefault();
                                if (formik.values.businessName && !formik.errors.businessName) {
                                  handleBusinessNameNext(e);
                                } else {
                                  formik.setFieldTouched('businessName', true);
                                }
                              }
                            }}
                          />
                        </div>
                      )}

                      {/* Next button for ABN step */}
                      {showABNField && !showBusinessNameField && (
                        <div className="flex justify-center w-full">
                          <div className="w-full mx-auto">
                            <div className="flex items-center justify-between mt-10 w-full">
                              <StepBackButton onClick={() => handleStepChange(3)} />
                              <MainButton
                                variant={"small"}
                                onClick={handleABNNext}
                              >
                                Next
                              </MainButton>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Next button for business name step */}
                      {showBusinessNameField && (
                        <div className="flex justify-center w-full">
                          <div className="w-full mx-auto">
                            <div className="flex items-center justify-between mt-10 w-full">
                              <StepBackButton onClick={handleBackToABN} />
                              <MainButton
                                variant={"small"}
                                onClick={handleBusinessNameNext}
                              >
                                Next
                              </MainButton>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </form>
              </div>
              {/* <WrittenStepper
                currentStep={step}
                lastStep={8}
                currentLabel={"Business information"}
                marginTop={"absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full"}
              /> */}
            </>
          )}
          {step === 5 && (
            <>
              <SelectService 
                onClickHandler={() => {
                  handleStepChange(6);
                }}
              />
              {/* <WrittenStepper
                currentStep={step}
                lastStep={9}
                currentLabel={"Select your service"}
                marginTop={"absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full"}
              /> */}
            </>
          )}
          {step === 6 && (
            <>
              <PrimarySkills
                onClickHandler={() => {
                  handleStepChange(7);
                }}
              />
              {/* <WrittenStepper
                currentStep={step}
                lastStep={9}
                currentLabel={"Featured services"}
                marginTop={"absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full"}
              /> */}
            </>
          )}
          {step === 7 && (
            <>
              <Location
                onClickHandler={() => {
                  handleStepChange(8);
                  setRequetStart(false);
                }}
              />
              {/* <WrittenStepper
                currentStep={step}
                lastStep={9}
                currentLabel={"Set your location"}
                marginTop={"absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full"}
              /> */}
            </>
          )}
          {step === 8 && (
            <>
              <AddProfilePicture
                onClickHandler={() => {
                  handleStepChange(9);
                }}
              />
              {/* <WrittenStepper
                currentStep={step}
                lastStep={9}
                currentLabel={"Upload your logo"}
                marginTop={"absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full"}
              /> */}
            </>
            
          )}
          {step === 9 && (
            <>
              <ProfilePreview
                step={step}
                lastStep={9}
                onClickHandler={onClickHandler}
              />
              {/* <WrittenStepper
                currentStep={step}
                lastStep={9}
                currentLabel={"Confirm & Preview profile"}
                marginTop={"absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full"}
              /> */}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default BusinessInfo;
